import axios from "axios";
import {
  shop_id,
  warehouse_id,
  para_id,
  warehouse,
  getLocalStorage,
} from "./function";
import { toast } from "react-toastify";
const timestamp = new Date().getTime();
const apiClient = axios.create({
  baseURL: `http://213.210.36.52:8002/`,
  // baseURL: `http://127.0.0.1:8000`,
  // base url:   http://213.210.36.52:8002/

});

apiClient.interceptors.request.use((config) => {
  const token = JSON.parse(getLocalStorage("AuthUser"))?.token;
  const user = JSON.parse(getLocalStorage("AuthUser"))?.user;
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  } else {
    config.headers["Content-Type"] = "application/json";
  }

  if (config.method === "get") {
    const role = user?.role_title?.toLowerCase();
    if (user && role !== "super admin" && role !== "admin") {
      config.params = {
        ...config.params,
        timestamp: new Date().getTime(),
      };
      if (user?.user_id) {
        // config.params.user_id = user.user_id;
      }
      if (
        shop_id &&
        !["/subcategories/list", "users/list_purchases_order_master"].some(
          (path) => config.url?.split("?")[0].includes(path)
        )
      ) {
        console.log(config.url?.split("?")[0]);
        config.params.shop_id = shop_id;
      }

      if (warehouse?.id) {
        // config.params.warehouse_id = warehouse.id;
      }
    } else {
      config.params = {
        ...config.params,
        timestamp: new Date().getTime(),
      };
    }
  }

  if (["post", "put"].includes(config.method?.toLowerCase())) {
    if (user) {
      if (config.data instanceof FormData) {
        if (shop_id && !config.data.has("shop_id")) {
          config.data.append("shop_id", shop_id);
        }
        if (warehouse?.id && !config.data.has("warehouse_id")) {
          config.data.append("ware_id", warehouse.id);
        }
      } else {
        if (config.data && typeof config.data === "object") {
          if (shop_id && config.data.shop_id === undefined) {
            config.data = {
              ...config.data,
              shop_id: shop_id,
            };
          }
          if (warehouse?.id && config.data.warehouse_id === undefined) {
            config.data = {
              ...config.data,
              ware_id: warehouse.id,
            };
          }
        }
      }
    }
  }

  return config;
},
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      console.log(error.response.data);
      if (
        error.response.data &&
        error.response.data.message == "Token has expired!"
      ) {
        console.log("Session expired. Logging out...");
        toast.error("Your token has expired!");
        setTimeout(() => {
          sessionStorage.clear();
          window.location.href = "/login";
        }, 1000);
      }
    }
    return Promise.reject(error);
  }
);

export { apiClient };
export const BASE_URL = `http://213.210.36.52:8002/`;
export const MediaUrl = `${BASE_URL}media/`;

export const getRoles = (page, text) =>
  apiClient.get(
    `/role/list?${page ? `page=${page}` : ``}${text ? `&role_title=${text}` : ``
    }`
  );
export const createRole = (data) => apiClient.post("/role/create", data);
export const updateRole = (id, data) =>
  apiClient.put(`/role/update/${id}`, data);
export const deleteRole = (id) => apiClient.delete(`/role/delete/${id}`);

//Menus
export const getMenus = () => apiClient.get("/menu/list");
export const createMenu = (data) => apiClient.post("/menu/create", data);
export const updateMenu = (id, data) =>
  apiClient.put(`/menu/update/${id}`, data);
export const deleteMenu = (id) => apiClient.delete(`/menu/delete/${id}`);

//Users
export const getAllUsers = (shop_id) =>
  apiClient.get(`/users/list?${shop_id ? `shop_id=${shop_id}` : ``}`);
export const getUsers = (page, text = "", shopid = shop_id) =>
  apiClient.get(
    `/users/list?${page ? `page=${page}` : ``}${`&full_name=${text ? text : ""
    }`}${`&shop_id=${shopid ? shopid : null}`}`
  );
export const createUser = (data) => apiClient.post("/users/create", data);
export const updateUser = (id, data) =>
  apiClient.put(`/users/update/${id}`, data);
export const deleteUser = (id) => apiClient.delete(`/users/delete/${id}`);

//Warehouse
export const getWarehouses = (page, text, shop = shop_id) =>
  apiClient.get(
    `/warehouse/list?${page ? `page=${page}` : ``}${text ? `&title=${text}` : ``
    }${shop ? `&shop_id=${shop}` : ``}`
  );
export const createWarehouse = (data) =>
  apiClient.post("/warehouse/create", data);
export const updateWarehouse = (id, data) =>
  apiClient.put(`/warehouse/update/${id}`, data);
export const deleteWarehouse = (id) =>
  apiClient.delete(`/warehouse/delete/${id}`);
export const getshopanalysis = (params) => {
  return apiClient.get(`shops/analytics?${params}`);
};


//Category
export const getCategory = (page, text) =>
  apiClient.get(
    `/categories/list?${shop_id ? `shop_id=${shop_id}` : ``}${page ? `&page=${page}` : ``}${text ? `&Categories=${text}` : ``
    }`
  );
export const createCategory = (data) =>
  apiClient.post("/categories/create", data);
export const updateCategory = (id, data) =>
  apiClient.put(`/categories/update/${id}`, data);
export const deleteCategory = (id) =>
  apiClient.delete(`/categories/delete/${id}`);

//Shops
// export const getShops = (page, text,id) => apiClient.get(`/shops/list?branch_id=${id ? id : ''}`);
export const getSubCompany = (page, text) =>
  apiClient.get(`/api/list_subcompany?para_id=1`);
export const deleteSubCompany = (id) =>
  apiClient.delete(`/api/delete_subcompany/${id}`);
export const createSubCompany = (data) =>
  apiClient.post("/api/create_subcompany", data);
export const updateSubCompany = (id, data) =>
  apiClient.put(`/api/update_subcompany/${id}`, data);

export const getShopsByCom = (id) => apiClient.get(`/shops/list_shop/${id ? id : ''}`);
export const getShops = (page, text) => apiClient.get(`/shops/list?branch_id=&page_size=1000`);
export const createShops = (data) => apiClient.post("/shops/create", data);
export const updateShops = (id, data) =>
  apiClient.put(`/shops/update/${id}`, data);
export const deleteShops = (id) => apiClient.delete(`/shops/delete/${id}`);

//SubCategory subcategory_name
export const getSubCategory = (page, text) =>
  apiClient.get(
    `/subcategories/list?${shop_id ? `shop_id=${shop_id}` : ``}${warehouse_id ? `&ware_id=${warehouse_id}` : ``}${page ? `&page=${page}` : ``}${text ? `&subcategory_name=${text}` : ``
    }`
  );
export const createSubCategory = (data) =>
  apiClient.post("/subcategories/create", data);
export const updateSubCategory = (id, data) =>
  apiClient.put(`/subcategories/update/${id}`, data);
export const deleteSubCategory = (id) =>
  apiClient.delete(`/subcategories/delete/${id}`);
export const getcategorybasesubcategory = (id) =>
  apiClient.get(`/subcategories/listbyid/${id}?${shop_id ? `shop_id=${shop_id}` : ``}${warehouse_id ? `&ware_id=${warehouse_id}` : ``}`);

//Suppliers
export const getSuppliers = (page, text) =>
  apiClient.get(
    `/suppliers/list?${shop_id ? `shop_id=${shop_id}` : ``}${page ? `&page=${page}` : ``}${text ? `&supplier_name=${text}` : ``
    }`
  );
export const createSupplier = (data) =>
  apiClient.post("/suppliers/create", data);
export const updateSupplier = (id, data) =>
  apiClient.put(`/suppliers/update/${id}`, data);
export const deleteSupplier = (id) =>
  apiClient.delete(`/suppliers/delete/${id}`);

//Products
export const getProducts = (search = "", page, ware_id = false) =>
  apiClient.get(
    `/products/list?${search ? `search=${search}` : ""}${page ? `&page=${page}` : ``
    }${`&ware_id=${ware_id ? ware_id : ""}`}${`&shop_id=${shop_id ? shop_id : ""
    }`}`
  );
export const createProduct = (data) => apiClient.post("/products/create", data);
export const bulk_product = (data) =>
  apiClient.post("/products/bulk_product", data);
export const updateProduct = (id, data) =>
  apiClient.put(`/products/update/${id}`, data);
export const deleteProduct = (id) => apiClient.delete(`/products/delete/${id}`);
export const getAllProducts = (shop = shop_id) =>
  apiClient.get(`/products/list_all_product?${`&shop_id=${shop ? shop : ""}`}`);
export const getDashboardReport = () =>
  apiClient.get(
    `/accounts/report?${shop_id ? `shop_id=${shop_id}` : ``}${warehouse_id ? `&ware_id=${warehouse_id}` : ``}`
  );
export const undoDeleteProduct = (id) =>
  apiClient.delete(`/products/undo/${id}`);

//unit
export const getUnits = () => apiClient.get("/products/list_unit");
export const createUnits = (data) =>
  apiClient.post("/products/create_unit", data);
export const updateUnits = (id, data) =>
  apiClient.put(`/products/update_unit/${id}`, data);
export const deleteUnits = (id) =>
  apiClient.delete(`/products/delete_unit/${id}`);

//tax
export const getTax = () => apiClient.get("/invoice/list_tax");
export const createTax = (data) => apiClient.post("/invoice/create_tax", data);
export const updateTax = (id, data) =>
  apiClient.put(`/invoice/update_tax/${id}`, data);
export const deleteTax = (id) => apiClient.delete(`/invoice/delete_tax/${id}`);

//Products Quantity
export const getProductsQty = (page, search, IN_OUT, ware_id = false) =>
  apiClient.get(
    `/products_quantity/list?${page ? `page=${page}` : ``}${`&ware_id=${ware_id ? ware_id : ""
    }`}${`&search=${search ? search : ""
    }`}${IN_OUT !== null ? `&in_or_out=${IN_OUT}` : ``}`
  );
export const getProductsExpiry = (page, ware_id, search, pro_id = false) =>
  apiClient.get(
    `/products_quantity/list_product_expiry?${page ? `page=${page}` : ``
    }${`&in_or_out=${"0"}`}${`&ware_id=${ware_id ? ware_id : ""
    }`}${`&search=${search ? search : ""
    }`}${`&product_id=${pro_id ? pro_id : ""}`}`
  );
export const createProductQty = (data) =>
  apiClient.post("/products_quantity/create", data);
export const shiftProduct = (data) =>
  apiClient.post("/products_quantity/shift_product", data);
export const updateProductQty = (id, data) =>
  apiClient.put(`/products_quantity/update/${id}`, data);
export const deleteProductQty = (id) =>
  apiClient.delete(`/products_quantity/delete/${id}`);
export const listtakenProductQty = (
  product_id,
  warehouse_id,
  manufacturer_id,
  supplier_id,
  brand_id
) =>
  apiClient.get(
    `/products_quantity/list_product_take?warehouse_id=${warehouse_id}&product_id=${product_id}&supplier_id=${supplier_id}&manufacturer_id=${manufacturer_id}&brand_id=${brand_id}`
  );
export const getProductDetail = (id, qty_id) =>
  apiClient.get(`/products_quantity/edit_product/${id}?qty_id=${qty_id}`);

//Customers
export const getCustomers = (page, text) =>
  apiClient.get(
    `/users/list_customers?${shop_id ? `&shop_id=${shop_id}` : ``}${page ? `&page=${page}` : ``}${text ? `&name=${text}` : ``
    }`
  );

export const createCustomers = (data) =>
  apiClient.post("/users/create_customers", data);
export const updateCustomers = (id, data) =>
  apiClient.put(`/users/update_customers/${id}`, data);
export const deleteCustomers = (id) =>
  apiClient.delete(`/users/delete_customers/${id}`);
//
export const getManufacturers = (page = 1, text = false) =>
  apiClient.get(
    `/products/list_manufacturers?${page ? `page=${page}` : ``}${shop_id ? `&shop_id=${shop_id}` : ``}${text ? `&name=${text}` : ""
    }`
  );
export const createManufacturers = (data) =>
  apiClient.post("/products/create_manufacturers", data);
export const updateManufacturers = (id, data) =>
  apiClient.put(`/products/update_manufacturers/${id}`, data);
export const deleteManufacturers = (id) =>
  apiClient.delete(`/products/delete_manufacturers/${id}`);
//brands
export const getBrand = (page, text) =>
  apiClient.get(
    `/products/list_brands?${page ? `page=${page}` : ``}${text ? `&name=${text}` : ``
    }`
  );
export const createBrand = (data) =>
  apiClient.post("/products/create_brands", data);
export const updateBrand = (id, data) =>
  apiClient.put(`/products/update_brands/${id}`, data);
export const deleteBrand = (id) =>
  apiClient.delete(`/products/delete_brands/${id}`);
//brancg
export const getBranch = () => apiClient.get("/branch/list");
export const createBranch = (data) => apiClient.post("/branch/create", data);
export const updateBranch = (id, data) =>
  apiClient.put(`/branch/update/${id}`, data);
export const deleteBranch = (id) => apiClient.delete(`/branch/delete/${id}`);
//scheduling
export const getTask = () => apiClient.get("/suppliers/list_sales_scheduling");
export const createTask = (data) =>
  apiClient.post("/suppliers/create_sales_scheduling", data);
export const updateTask = (id, data) =>
  apiClient.put(`/suppliers/update_sales_scheduling/${id}`, data);
export const deleteTask = (id) =>
  apiClient.delete(`/suppliers/delete_sales_scheduling/${id}`);
//scheduling
export const getSales = () => apiClient.get("/users/list_purchases_order");
export const createSales = (data) =>
  apiClient.post("/users/list_purchases_order", data);
export const updateSales = (id, data) =>
  apiClient.put(`/users/list_purchases_order/${id}`, data);
export const deleteSales = (id) =>
  apiClient.delete(`/users/list_purchases_order/${id}`);
// Quotation
export const getQuotation = (page, text, shop_id, filters) =>
  apiClient.get('/users/list_quotation_master', {
    params: {
      ...(page && { page }),
      ...(text && { quotation_number: text }),
      ...(shop_id && { shop_id }),
      ...(filters?.from_date && { from_date: filters.from_date }),
      ...(filters?.to_date && { to_date: filters.to_date }),
      ...(filters?.approval_status && { approval_status: filters.approval_status }),
    },
  });

export const createQuotation = (data) =>
  apiClient.post("/users/create_quotation", data);
export const updateQuotation = (id, data) =>
  apiClient.put(`/users/update_quotation/${id}`, data);
export const deleteQuotation = (id) =>
  apiClient.delete(`/users/delete_quotation/${id}`);

// Quotation Order
export const getQuotationorder = (id) =>
  apiClient.get(`users/list_quotation_details?quota_id=${id}`);
export const createQuotationorder = (data) =>
  apiClient.post("users/create_quotation_details", data);
export const updateItemQuotationOrder = (id, data) =>
  apiClient.put(`users/update_quotation_details/${id}`, data);
export const deleteQuotationorder = (id) =>
  apiClient.delete(`users/delete_quotation_details/${id}`);

//LOGIN
export const createBulkPurchase = (data) =>
  apiClient.post("/products_quantity/create_bulk_purchase", data);
export const createBulkPurchaseOrder = (data) =>
  apiClient.post("/products_quantity/create_bulk_purchase_order", data);
export const createBulkQuotation = (data) =>
  apiClient.post("/products_quantity/create_bulk_quotation", data);

// Purchase
export const getPurchase = (page, text, status = 1, shop_id, filters) =>
  apiClient.get(
    `users/list_purchases_order_master?status=${status}&${page ? `page=${page}` : ``
    }${text ? `&po=${text}` : ``}${shop_id ? `&shop_id=${shop_id}` : ``}${filters?.start_date ? `&start_date=${filters.start_date}` : ""}${filters?.end_date ? `&end_date=${filters.end_date}` : ""}`
  );
export const login = (data) => apiClient.post("/users/login", data);
export const takenQty = (data, id) =>
  apiClient.post(`/products_quantity/add_taken?id=${id}`, data);

// Purchase
export const createPurchase = (data) =>
  apiClient.post("/users/create_purchases", data);
export const updatePurchaseCredit = (data) =>
  apiClient.post("products_quantity/update_purchase", data);
export const updatePurchase = (id, data) =>
  apiClient.put(`/users/update_purchases/${id}`, data);
export const deletePurchase = (id) =>
  apiClient.delete(`/users/delete_purchases/${id}`);
export const uploadInvoice = (data) =>
  apiClient.post("/products_quantity/update_invoice", data);

// Purchase Order
export const getPurchaseorderDetail = (id) =>
  apiClient.get(`users/list_purchase_order_details/${id}`);
export const getQuotationOrderDetail = (id) =>
  apiClient.get(`users/list_quotation_order_details/${id}`);
export const updateQu_ProDetail = (id) =>
  apiClient.put(`users/update_qu_product/${id}`);
export const createPurchaseorder = (data) =>
  apiClient.post("/users/create_purchase_order", data);
export const updatePurchaseorder = (id, data) =>
  apiClient.put(`/users/update_purchase_order/${id}`, data);
export const deletePurchaseorder = (id) =>
  apiClient.delete(`/users/delete_purchase_order/${id}`);
export const getPurchaseOrder = (id) =>
  apiClient.get(`products_quantity/get_purchase_order?po_id=${id}`);
export const updateItemPurchaseOrder = (id, data) =>
  apiClient.post(`products_quantity/update_purchase_order?po_id=${id}`, data);
export const addInventoryOrder = (id, data) =>
  apiClient.post(`products_quantity/add_Inventory_order?po_id=${id}`, data);
export const addQuotationOrder = (id, data) =>
  apiClient.post(
    `products_quantity/add_Quation_order?quotation_number=${id}`,
    data
  );

// WarehouseBasedProduct
export const getWarehouseProduct = (id) =>
  apiClient.get(`products/list?ware_id=${id}`);

export const getproductvalue = (ware_id, pageOff = false, search = '', shopId = '') =>
  apiClient.get(`api/list_processing?warehouse_id=${ware_id}&pageoff=${pageOff}&search=${search}${shopId ? `&shop_id=${shopId}` : ''}`);

//sales Windows
export const createBulkOrder = (data) =>
  apiClient.post(`order/create_bulk_order`, data);
export const ReturnSales = (data, shop_id) =>
  apiClient.post(`order/sales_return?shop_id=${shop_id}`, data);
export const ReturnPurchase = (data, shop_id) =>
  apiClient.post(`order/purchases_return?shop_id=${shop_id}`, data);

export const updateSalesCredit = (data) =>
  apiClient.post("order/update_order", data);
export const ListOrder = (id) =>
  apiClient.get(`order/list_order_details?order_id=${id}`);
export const ListOrder1 = (id) =>
  apiClient.get(`order/list_order_details?id=${id}`);
export const ListOrderById = (id) =>
  apiClient.get(`order/list_order_master_al?unique_id=${id}`);
// export const ListPurchaseById = (id) =>apiClient.get(`users/list_purchases_al?po=${id}`);
export const ListPurchaseById = (id) =>
  apiClient.get(`products_quantity/get_purchase_order?po_id=${id}`);
export const ListSalesOrder = (id, shop_id) => apiClient.get(`order/listsale?id=${id}&shop_id=${shop_id}`);
export const ListPurchaseOrder = (id, shop_id) => apiClient.get(`order/listpurchase?id=${id}&shop_id=${shop_id}`);

export const ListOrderMaster = (page, shop_id, filters) =>
  apiClient.get(
    `order/list_order?${page ? `page=${page}` : ""}${shop_id ? `&shop_id=${shop_id}` : ""
    }${filters?.from_date ? `&from_date=${filters.from_date}` : ""}${filters?.to_date ? `&to_date=${filters.to_date}` : ""}${filters?.uniqueId ? `&unique_id=${filters.uniqueId}` : ""}${filters?.status ? `&status=${filters.status}` : ""
    }`
  );

export const ListFinance = () => apiClient.get(`invoice/list_finance`);
export const SearchsalesDetails = (search) =>
  apiClient.get(`order/search_sales_details?search=${search}`);
export const AddRemark = (data, id) =>
  apiClient.post(`order/add_remark?id=${id}`, data);

export const getDocumentsType = (page, text) =>
  apiClient.get(
    `documents/list_documents_type?${page ? `page=${page}` : ``}${text ? `&Categories=${text}` : ``
    }`
  );
export const createDocumentsType = (data) =>
  apiClient.post("documents/create_documents_type", data);
export const updateDocumentsType = (id, data) =>
  apiClient.put(`/documents/update_documents_type/${id}`, data);
export const deleteDocumentsType = (id) =>
  apiClient.delete(`/documents/delete_documents_type/${id}`);



//Document Table
export const getDocumentsTable = (empId, page, text, shop_id) =>
  apiClient.get(
    `documents/list_documents_table?emp_id=${empId ? empId : ""}${shop_id ? `&shop_id=${shop_id}` : ``
    }${page ? `&page=${page}` : ``}${text ? `&Categories=${text}` : ``}`
  );
export const getDocumentsTableV2 = (query) =>
  apiClient.get(`documents/list_documents_table?${query}`);
export const createDocumentsTable = (data) =>
  apiClient.post("documents/create_documents_table", data);
export const updateDocumentsTable = (id, data) =>
  apiClient.put(`/documents/update_documents_table/${id}`, data);
export const deleteDocumentsTable = (id) =>
  apiClient.delete(`/documents/delete_documents_table/${id}`);

//Document Details
export const getDocumentsDetails = (page, text) =>
  apiClient.get(
    `documents/list_documents_details?${page ? `page=${page}` : ``}${text ? `&Categories=${text}` : ``
    }`
  );
export const createDocumentsDetails = (data) =>
  apiClient.post("documents/create_documents_details", data);
export const updateDocumentsDetails = (id, data) =>
  apiClient.put(`/documents/update_documents_details/${id}`, data);
export const deleteDocumentsDetails = (id) =>
  apiClient.delete(`/documents/delete_documents_details/${id}`);

//Add Receipt
export const StoreReceipt = (data) =>
  apiClient.post("order/store_receipt", data);
export const ListReceipt = (data) => apiClient.get("order/list_receipt");

// Parent Company
export const createParentCompany = (data) =>
  apiClient.post("/parent_company/create", data);
export const updateParentCompany = (id, data) =>
  apiClient.put(`/parent_company/update/${id}`, data);

// Project
export const createProject = (data) => apiClient.post("projects/create", data);
export const updateProject = (id, data) =>
  apiClient.put(`projects/update/${id}`, data);
export const ListProject = (data) =>
  apiClient.get(`projects/list?${shop_id ? `shop_id=${shop_id}` : ``}`);
export const ListProjectDetail = (id) =>
  apiClient.get(`projects/list_projects_details?id=${id}`);
export const DeleterProject = (id) => apiClient.delete(`projects/delete/${id}`);
export const create_project_assign = (data) =>
  apiClient.post(`projects/create_project_assign`, data);
export const update_project_assign = (id, data) =>
  apiClient.put(`projects/update_project_assign/${id}`, data);

export const ListProjectAssign = (emp) =>
  apiClient.get(`projects/list_project_assign${emp ? `?emp_id=${emp}` : ``}`);
export const List_Feedback = () => apiClient.get(`feedback/list`);

export const ListSalesReport = (data) =>
  apiClient.get(`order/list_order?${data}`);
export const ListUserReport = (data) => apiClient.get(`users/list?${data}`);
export const ListPOReport = (data) =>
  apiClient.get(`users/list_purchases_order_master?${data}`);

//Client
export const createClinet = (data) =>
  apiClient.post("projects/create_client", data);
export const updateClinet = (id, data) =>
  apiClient.put(`projects/update_client/${id}`, data);
// export const ListClient = (data) => apiClient.get('projects/list_client');
export const ListClient = (data) => apiClient.get("projects/list_client");
export const deleteClient = (id) =>
  apiClient.delete(`projects/delete_client/${id}`);

//Category
export const createCategoryclient = (data) =>
  apiClient.post("/projects/create_todocategory", data);
export const ListCategoryClient = (data) =>
  apiClient.get("projects/list_todocategory");
export const updateCategoryClinet = (id, data) =>
  apiClient.put(`projects/update_todocategory/${id}`, data);
export const deletecategoryClient = (id) =>
  apiClient.delete(`projects/delete_todocategory/${id}`);

//TODO
export const createTodo = (data) =>
  apiClient.post("projects/create_todo", data);
export const ListTodo = (data) =>
  apiClient.get(`projects/list_todo?${shop_id ? `shop_id=${shop_id}` : ``}`);
export const updateTodo = (id, data) =>
  apiClient.put(`projects/update_todo/${id}`, data);
export const deleteTodo = (id) =>
  apiClient.delete(`projects/delete_todo/${id}`);
export const ListTodoByProject = (id) =>
  apiClient.get(`projects/list_project?project_id=${id}`);

//Accountslist
export const Accountlist = (data) => apiClient.get("accounts/list");
export const AccountDetailslist = (data) =>
  apiClient.post("accounts/list_filter_accounts", data);
export const AccountDataList = (data) =>
  apiClient.get(`order/product_profit_loss?${data}`);

//Expanse
export const createExpanse = (data) => apiClient.post("expense/create", data);
export const getExpanses = (query) => apiClient.get(`expense/list?${query}`);
export const getPettyCash = (data) =>
  apiClient.get(
    `expense/list_petty_cash?${shop_id ? `shop_id=${shop_id}` : ``}`
  );
export const updateExpanse = (id, data) =>
  apiClient.put(`expense/update/${id}`, data);
export const deleteExpanse = (id) => apiClient.delete(`expense/delete/${id}`);

//client_feedback
//client_feedback

//client_feedback
export const createfeedback = (data) => apiClient.post("feedback/create", data);
export const getfeedback = (data) => apiClient.get("feedback/list");
export const updatefeedback = (id, data) =>
  apiClient.put(`feedback/update/${id}`, data);
export const deletefeedback = (id) => apiClient.delete(`feedback/delete/${id}`);

//Cash_Counter
export const createcashcounter = (data) => apiClient.post("cash/create", data);
export const getcashcounter = (data) => apiClient.get("cash/list");
export const updatecashcounter = (id, data) =>
  apiClient.put(`cash/update/${id}`, data);
export const deletecashcounter = (id) => apiClient.delete(`cash/delete/${id}`);

//services
export const createAssets = (data) => apiClient.post("assets/create", data);
export const createPayment = (data) =>
  apiClient.post("/products/create_payment", data);
export const getReportData = (shop_id, start_date, end_date) =>
  apiClient.get(
    `order/purchase_sales_list?shop_id=${shop_id ? shop_id : ""}&start_date=${start_date ? start_date : ""
    }&end_date=${end_date ? end_date : ""}`
  );
export const listAssets = (shop_id, start_date, end_date) =>
  apiClient.get(
    `assets/list?shop_id=${shop_id ? shop_id : ""}&from_date=${start_date ? start_date : ""
    }&to_date=${end_date ? end_date : ""}`
  );
export const createServices = (data) => apiClient.post("service/create", data);
export const getServices = (data, shop = shop_id) =>
  apiClient.get(`service/list?${shop ? `shop_id=${shop}` : ``}`);
export const updateServices = (id, data) =>
  apiClient.put(`service/update/${id}`, data);
export const deleteServices = (id) => apiClient.delete(`service/delete/${id}`);
export const createPurchaseprocess = (data) =>
  apiClient.post("api/add_finished_product_direct", data);

export const createServiceExpense = (data) =>
  apiClient.post("service/create_service_expenses", data);
export const updateServiceExpense = (id, data) =>
  apiClient.put(`service/update_service_expenses/${id}`, data);
export const ListServiceExpense = (page) =>
  apiClient.get(`service/list_service_expenses`);
export const ListServiceDetails = (id) =>
  apiClient.get(`service/list_ss?service_id=${id}`);
export const deleteServiceExpense = (id) =>
  apiClient.delete(`service/delete_service_expenses/${id}`);

// Project List
export const ListProjectTodo = (emp_id) =>
  apiClient.get(`projects/list_todo?emp_id=${emp_id ? emp_id : ""}`);
export const CreateTaskTrack = (data) =>
  apiClient.post("tasktracking/create", data);
export const ListTaskTimer = (data) =>
  apiClient.post("tasktracking/list_task_timer", data);
export const DeleteTaskExpense = (id) =>
  apiClient.delete("tasktracking/delete_expenses/" + id);

export const getInvoiceNumber = (type) =>
  apiClient.get(`users/get_invoice_number?type=${type ? type : ""}${shop_id ? `&shop_id=${shop_id}` : ``}`);

//task Expenses
export const CreateTaskExpenses = (data) =>
  apiClient.post("tasktracking/expenses_create", data);
export const UpdateTaskExpenses = (id, data) =>
  apiClient.put(`tasktracking/update_expense/${id ? id : ""}`, data);
export const ListTaskExpenses = (type, project_id) =>
  apiClient.get(
    `tasktracking/list_expense?type=${type ? type : "1"}&project_id=${project_id ? project_id : ""
    }`
  );

//Pruchase Lists
export const UpdatePurchasepayment = (Id, data) =>
  apiClient.put(`users/update_purchase_unit/${Id ? Id : ""}`, data);
export const Updateorderpayment = (Id, data) =>
  apiClient.put(`order/update_purchase_unit/${Id ? Id : ""}`, data);

// product stock list
export const Listprostock = (data) =>
  apiClient.get(
    `products/stock_alert_list?${shop_id ? `shop_id=${shop_id}` : ``}${warehouse_id ? `&ware_id=${warehouse_id}` : ``
    }`
  );
export const Documentexp = (data) =>
  apiClient.get(
    `documents/documents_expiry_alert?${shop_id ? `shop_id=${shop_id}` : ``}`
  );

//budget

//budget
export const Listbudget = (project_id) =>
  apiClient.get(
    `expense/list_budget?project_id=${project_id ? project_id : ""}`
  );
export const Createbuget = (data) =>
  apiClient.post("expense/create_budget", data);
export const Updatebuget = (id, data) =>
  apiClient.put(`expense/update_budget/${id ? id : ""}`, data);
export const Deletebuget = (id) =>
  apiClient.delete("expense/delete_budget/" + id);
// supplier receipt
// supplier receipt
export const Suppliercredit = (shop_id, page, search) =>
  apiClient.get(
    `users/suppliers_credit_list?${page ? `&page=${page}` : ``}
    ${search ? `&search=${search}` : ``}${shop_id ? `&shop_id=${shop_id}` : ``
    }`
  );
export const SupplierPurchaseDetails = (supplier_id, shop_id, page) =>
  apiClient.get(
    `users/suppliers_credit_list_all?supplier_id=${supplier_id ? supplier_id : ""
    }${page ? `&page=${page}` : ``}${shop_id ? `&shop_id=${shop_id}` : ``}`
  );
export const CustomerCredit = (shop_id, page, Search) =>
  apiClient.get(
    `order/customer_credit_list?${page ? `&page=${page}` : ``}${Search ? `&search=${Search}` : ``
    }${shop_id ? `&shop_id=${shop_id}` : ``
    }`
  );

export const CustomerCreditDetails = (supplier_id, shop_id, page) =>
  apiClient.get(
    `order/customer_credit_list_all?customer_id=${supplier_id ? supplier_id : ""
    }${page ? `&page=${page}` : ``}${shop_id ? `&shop_id=${shop_id}` : ``}`
  );

//profit and lose product  order/product_profit_loss
export const Productpolo = () => apiClient.get(`order/product_profit_loss`);

//Project Discussion
export const ProjectDiscussionCreate = (data) =>
  apiClient.post(`/project_discussion/create`, data);
export const ProjectDiscussionList = (id) =>
  apiClient.get(`/project_discussion/list?project_id=${id}`);
//comapny accounts
export const Companyreport = (id) => apiClient.get(`accounts/company_accounts`);
//password update

//password update
export const Updatepassword = (data) =>
  apiClient.post(`users/update_password`, data);
//notification
export const getNotification = (shop_id) =>
  apiClient.get(
    `documents/get_summary_counts?${shop_id ? `&shop_id=${shop_id}` : ``}${warehouse_id ? `&ware_id=${warehouse_id}` : ``
    }`
  );
export const getExpiryDocuments = (shop_id, text, page) =>
  apiClient.get(
    `documents/list_expiry_document?${shop_id ? `&shop_id=${shop_id}` : ``}${page ? `&page=${page}` : ``}${text ? `&search=${text}` : ``
    }`
  );
export const getMostReportData = (shop_id, start_date, end_date) =>
  apiClient.get(
    `accounts/get_most_items?shop_id=${shop_id ? shop_id : ""}&from_date=${start_date ? start_date : ""
    }&to_date=${end_date ? end_date : ""}`
  );

// Transaction API
export const create_project_trans = (data) =>
  apiClient.post(`projects/transactions/create`, data);
export const list_project_trans = (id) =>
  apiClient.get(`projects/transactions/list?id=${id}`);
export const update_project_trans = (id, data) =>
  apiClient.post(`projects/transactions/update/${id}`, data);
export const delete_project_trans = (id, p_id) =>
  apiClient.get(`projects/transactions/delete/${id}?project_id=${p_id}`);

// Report
export const getSupplierTransacton = (query) =>
  apiClient.get(`products/list_purchases_by_supplier?${query}`);
export const getCustomerTransacton = (query) =>
  apiClient.get(`products/list_customer_transcation?${query}`);
export const getSalesReport = (query) =>
  apiClient.get(`api/list_order_master?${query}`);
export const getDailySalesReport = (query) =>
  apiClient.get(`order/daily_sales_report?${query}`);
export const getPurchaseReport = (query) =>
  apiClient.get(`users/list_purchases_order_master?${query}`);
export const getServicesPayment = (id) =>
  apiClient.get(`service/get_service?service_id=${id}`);
export const getTrialBalanceOld = (query) =>
  apiClient.get(`/products_quantity/amount_get?${query}`);
export const getTrialBalance = (query) =>
  apiClient.get(`/products_quantity/amount_get_v2?${query}`);
export const getServiceTransacton = (query) =>
  apiClient.get(`products/list_service_transcation?${query}`);
export const getServiceReport = (query) =>
  apiClient.get(`service/list?${query}`);
export const getPDTDataOld = (query) =>
  apiClient.get(`products/list_payment_details?${query}`);
export const getPDTData = (query) =>
  apiClient.get(`products/list_payment_details_v2?${query}`);



//Email 


//Email 
export const createEmail = (data) =>
  apiClient.post("accounts/create_email", data);
export const getEmail = (query) =>
  apiClient.get(`accounts/list_email`);
export const updateEmail = (id, data) =>
  apiClient.put(`accounts/update_email/${id}`, data);
export const deleteEmail = (id) =>
  apiClient.delete(`accounts/delete_email/${id}`);

export const UpdatePrimaryEmail = (id) =>
  apiClient.get(`accounts/activate_email?id=${id}`);


//terms and conditions 
export const createTerms = (data) =>
  apiClient.post("/api/terms_create", data);
export const getTerms = (query) =>
  apiClient.get(`/api/terms_list?${query}`);
export const updateTerms = (id, data) =>
  apiClient.put(`/api/terms_update/${id}`, data);
export const deleteTerms = (id) =>
  apiClient.delete(`/api/terms_delete/${id}`);


//Serial number 
export const get_po_serial_number = (PO_ID) =>
  apiClient.get(
    `/api/list_Product_SerialNumbers?p_id=${PO_ID}${shop_id ? `&shop_id=${shop_id}` : ``}${warehouse_id ? `&ware_id=${warehouse_id}` : ``}`
  );

export const updateProductSerialNumber = (id, data) =>
  apiClient.put(
    `/api/update_Product_SerialNumber/${id}`,
    data
  );

// order return list
export const get_order_returnlist = (data) =>
  apiClient.get(`/order/return_list${shop_id ? `?shop_id=${shop_id}` : ''}`, data);

//Sales Return
export const ProductReturn = (data) =>
  apiClient.post("order/product_return", data);

export const PurchasesReturn = (data) =>
  apiClient.post("order/purchases_return", data);

export const postGeneralData = (data) =>
  apiClient.post("accounts/add_General_Ledger", data);
export const postGeneralDataNew = (data) =>
  apiClient.post("accounts/add_General_Ledger_New", data);

export const updateCapitalAndLedger = (data) =>
  apiClient.post("accounts/update_capital_general_ledger", data);

export const EditGeneralData = (data) =>
  apiClient.put("accounts/edit_General_Ledger", data);

export const getGeneralData = (query) =>
  apiClient.get(`accounts/list_General_Ledger?${query}`);

export const getProfitLoss = (data) =>
  apiClient.get(`accounts/list_profit_loss?${shop_id ? `&shop_id=${shop_id}` : ``}`, { params: data });

export const getTrialBalanceData = (data) =>
  apiClient.get(`accounts/NewTrailBalance?${shop_id ? `&shop_id=${shop_id}` : ``}`, { params: data });

export const getProductInfo = (p_id, data) =>
  apiClient.get(`api/serial_number_summary?${shop_id ? `&shop_id=${shop_id}` : ``}${warehouse_id ? `&ware_id=${warehouse_id}` : ``}${p_id ? `&p_id=${p_id}` : ``}`, { params: data });
export const getPurchaseReturnList = (data) =>
  apiClient.get(`order/list_purchase_returns?${shop_id ? `&shop_id=${shop_id}` : ``}`, { params: data })

export const UpdatePaymentComplete = (data) =>
  apiClient.post(`accounts/update_payment_complete`, data);

export const getAllTransaction = (query) =>
  apiClient.get(`accounts/all_transactions?${query}`);

export const getTransactionHistory = (query) =>
  apiClient.get(`products/transaction_history?${query}`);
export const getStockReport = (query) =>
  apiClient.get(`api/product_details?${query}`);

export const transferProducts = (data) =>
  apiClient.post(`products/transfer_products`, data);


// export const getProductMaster = (data) =>
//   apiClient.get("api/list_product_master", data);



export const create_product_master = (data) =>
  apiClient.post("api/create_product_master", data);

export const updateProductMaster = (id, data) =>
  apiClient.put(`/api/update_product_master/${id}`, data);
export const deleteProductMaster = (id, data) =>
  apiClient.delete(`/api/delete_product_master/${id}`, data);


// export const getRawMaterials = (data) =>
//   apiClient.get("api/list_rawmaterial", data);

export const createRawMaterials = (data) =>
  apiClient.post("api/create_rawmetarial", data);

export const updateRawMaterials = (id, data) =>
  apiClient.put(`/api/update_rawmetarial/${id}`, data);
export const deleteRawMaterials = (id, data) =>
  apiClient.delete(`/api/delete_rawmetarial/${id}`, data);

export const getProductProcessing = (data) =>
  apiClient.get("api/list_product_processing", data);

export const createProductProcessing = (data) =>
  apiClient.post("api/create_product_processing", data);

export const updateProductProcessing = (id, data) =>
  apiClient.put(`/api/update_product_processing/${id}`, data);
export const deleteProductProcessing = (id, data) =>
  apiClient.delete(`/api/delete_rawmetarial/${id}`, data);





// export const get_product_transection = (data,page, search,add_taken) => 
// apiClient.get("api/list_raw_metarials_transaction", {
//   params: {
//     ...data,
//     page,
//     search,
//     add_taken,
//   },
// });
export const get_product_transection1 = () =>
  apiClient.get("api/list_product_transactions", {
    params: {
      ware_id: warehouse_id,
      shop_id: shop_id
    }
  });

export const get_expiring_raw_data = (page, shop_id, search, days) =>
  apiClient.get("api/list_expiring_raw_materials", {
    params: {
      page,
      shop_id: shop_id,
      search,
      ...(days ? { days } : {}),
    },
  });
export const get_expiring_products = (page, shop_id, search, days) =>
  apiClient.get("api/list_expiring_products", {
    params: {
      page,
      shop_id: shop_id,
      search,
      ...(days ? { days } : {}),
    },
  });




export const create_rawtransection = (data) =>
  apiClient.post("api/create_rawmaterial_transaction", data);

export const create_product_transection = (data) =>
  apiClient.post("api/create_product_transaction", data);

export const create_product_ingredients = (data) => {
  apiClient.post('/api/create_product_processing', data);
};


export const get_product_ingredients = (data, product_id) =>
  apiClient.get("api/get_product_ingredients", {
    params: {
      ...data,
      product_id,
    },
  });

//sales 
export const create_sale_transection = (data) =>
  apiClient.post("api/order/create_bulk_order", data);

//process 
export const add_process_charges = (data) =>
  apiClient.put(`api/update_processing`, data);
export const update_product_process_status = (data) =>
  apiClient.put(`api/update_processing_status`, data);
export const cancel_processing = (data) =>
  apiClient.post("api/cancel_processing", data);

export const create_product_processing = (data) =>
  apiClient.post("api/create_processing", data);

// export const get_product_processing = (data) =>
//   apiClient.get("api/list_processing", data);





//product order
export const create_productorder_processing = (data) =>
  apiClient.post("api/create_product_order", data);
export const update_product_order = (data) =>
  apiClient.put(`api/update_product_order`, data);

// export const get_product_orders = (data) =>
// apiClient.get(`api/list_product_orders`, data);

export const get_product_order_details = (params) =>
  apiClient.get(`api/list_product_order_details`, { params });

export const get_product_order_details1 = (id) =>
  apiClient.get(`api/list_product_order_details?om_id=${id}`);
export const get_product_order_details2 = (id) =>
  apiClient.get(`order/list_order_details?id=${id}`);

//payment
export const create_product_payment = (data) =>
  apiClient.post("api/create_product_order_payment", data);


//product master details 

export const create_product_details = (data) =>
  apiClient.post("api/create_product_details", data);

// export const get_product_details = (data) =>
// apiClient.get(`api/list_product_details`, data);

export const update_product_details = (id, data) =>
  apiClient.put(`api/update_product_details/${id}`, data);

export const finalize_processing = (data) =>
  apiClient.put("api/finalize_processing", data);

export const list_raw_material_transactions = (processingId) => {
  return apiClient.get(`/api/list_raw_material_transactions/${processingId}`);
};

export const get_completed_process_details = (processingId) => {
  return apiClient.get(`/api/get_completed_process_details/${processingId}`);
};

export const delete_product_details = (id) =>
  apiClient.delete(`/api/delete_product_details/${id}`);

//filter 

export const getRawMaterials = () =>
  apiClient.get("api/list_rawmaterial", {
    params: {
      ware_id: warehouse_id,
      shop_id: shop_id
    },
  });

export const get_product_transection = (data, page, search, add_taken) =>
  apiClient.get("api/list_raw_metarials_transaction", {
    params: {
      ...data,
      page,
      search,
      add_taken,
      ware_id: warehouse_id,
      shop_id: shop_id
    },
  });

export const get_rawtransaction = (page, page_size, search, add_taken) =>
  apiClient.get("api/list_raw_metarials_transaction", {
    params: {
      page,
      page_size,
      search,
      add_taken,
      ware_id: warehouse_id,
      shop_id: shop_id
    },
  });

export const getProductMaster = () =>
  apiClient.get("api/list_product_master", {
    params: {
      shop_id: shop_id
    },
  });

export const get_product_details = (data) =>
  apiClient.get("api/list_product_details", { params: data });

export const get_product_processing = (data) =>
  apiClient.get("api/list_processing", { params: data });

export const get_product_orders = (data) =>
  apiClient.get("api/list_product_orders", { params: data });

export const get_product_detail_transection = (add_taken) =>
  apiClient.get("api/list_product_master_details_transaction", {
    params: {
      ware_id: warehouse_id,
      shop_id: shop_id,
      add_taken
    }
  });

export const Order_status_update = (data) =>
  apiClient.post("api/update_order_status", data);

export const Edit_order_update = (data) =>
  apiClient.post("api/edit_product_order", data);

export const listProductQty = (data, productId) => apiClient.get(`/api/list_productsqty?p_id=${productId}`, data);

// Utility/Api.js
export const getShareHolders = (data) => apiClient.get('/api/list_shareholders', { params: data });
export const addShareHolder = (data) => apiClient.post('/api/create_shareholder', data);
export const updateShareHolder = (id, data) => apiClient.put(`/api/update_shareholders/${id}`, data);
export const deleteShareHolder = (id) => apiClient.delete(`/api/delete_shareholders/${id}`);

export const addShareHolderDetails = (data) => apiClient.post("/api/create_shareholder_details", data);
export const getShareHolderDetails = (id) => apiClient.get(`/api/list_shareholder_details?sh_id=${id}`);

//Loan
export const createLoanData = (data) => apiClient.post("/accounts/create_loan", data);
export const getLoanDetails = (data) => apiClient.get("/accounts/list_loans", { params: data });
export const getBankBalance = (shop_id) => apiClient.get(`/accounts/bank_balance?shop_id=${shop_id || ""}`);
export const getPosBatch = (data) => apiClient.get("/api/profit_loss_batch_report", { params: data });

//sharedisctribution

export const createShareList = (data) => apiClient.post("/api/shareholder_distribution", data);
export const getSharePayment = (data) => apiClient.get("/api/list_shareholder_profit_distribution", { params: data });

// Equity
export const createEquityEntry = (data) => apiClient.post("/api/create_equity_entry", data);
export const getEquityEntries = (params) => apiClient.get("/api/list_equity_entries", { params });






// Salary Module
export const createSalaryPayment = (data) => apiClient.post("/salary/create/", data);
export const deleteSalaryPayment = (id) => apiClient.delete(`/salary/delete/${id}/`);

// Fixed Assets Module
export const createFixedAsset = (data) => apiClient.post("assets/create_fixed_asset", data);
export const listFixedAssets = (params) => apiClient.get("assets/list_fixed_assets", { params });
export const deleteFixedAsset = (id) => apiClient.delete(`assets/delete_fixed_asset/${id}`);

export const getSalaryPayments = (params) => apiClient.get("/salary/list/", { params });
export const getPendingAdvance = (params) => apiClient.get("/salary/pending-balance/", { params });
export const getAdvanceReport = (params) => apiClient.get("/salary/advance-report/", { params });
